import { AfterContentInit, Directive, ElementRef, Input, Renderer2, inject } from '@angular/core';

@Directive({
  selector: '[appAutocompleteOff]',
  standalone: false,
})
export class AutocompleteOffDirective implements AfterContentInit {
  @Input() public appAutocompleteOff;
  @Input() public autocompleteOffTimeout = 300;

  private renderer = inject(Renderer2);

  public constructor(private el: ElementRef) {}

  public ngAfterContentInit() {
    if (this.appAutocompleteOff === '' || this.appAutocompleteOff === true) {
      this.setAutocompleteOff();
    } else if (this.appAutocompleteOff === 'xiInput') {
      this.setAutocompleteOff('input');
    } else if (this.appAutocompleteOff === 'xiTextArea') {
      this.setAutocompleteOff('textarea');
    }
  }

  private setAutocompleteOff(selector?: string) {
    setTimeout(() => {
      let inputElement = this.el.nativeElement;
      if (selector) {
        inputElement = inputElement.querySelector(selector);
      }

      if (inputElement) {
        this.renderer.setAttribute(inputElement, 'autocomplete', 'off');
      }
    }, this.autocompleteOffTimeout);
  }
}
